import { useEffect } from 'react'
import { useSearchParams } from 'react-router-dom'
import ContractHtml from '@/components/forms/contract/ContractHtml'
import { useContractPdf } from '@/components/forms/contract/useContractPdf'
import { useGetContracts } from '@/api/contract/GetContracts'

const ContractPreviewPage = () => {
  const [params] = useSearchParams()
  const categoryId = params.get('categoryId')

  const { data, isLoading } = useGetContracts({})
  const { generatePdf } = useContractPdf()

  const category =
    data?.categories_commission?.find((c) => String(c.id) === categoryId) ??
    null

  useEffect(() => {
    if (data && category) {
      setTimeout(() => {
        generatePdf()
      }, 300)
    }
  }, [data, category])

  if (isLoading) return null

  return (
    <div style={{ background: '#fff', padding: 24 }}>
      <ContractHtml data={data} category={category} />
    </div>
  )
}

export default ContractPreviewPage
